import React, { useEffect, useRef, useState } from 'react';

import { Container, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import User from '../../models/User';
import EditFields from '../common/EditFields';
import LoadingButton from '../common/LoadingButton';

const useStyles = makeStyles((theme) => ({
  bold: {
    fontWeight: 'bold',
  },
  mainContainer: {
    padding: '30px',
  },
  submitContainer: {
    paddingTop: theme.spacing(4),
  },
}));

export default ({ user, onInvite, title, hint, fields, buttonText, note, isSubmitting$, errors }) => {
  const defaultData = user || new User();
  const classes = useStyles();

  const [validationErrors, setValidationErrors] = useState(errors);
  useEffect(() => {
    setValidationErrors(errors);
  }, [errors]);

  const inviteFieldRef = useRef();
  const onInviteClick = async () => {
    const validData = await inviteFieldRef.current.getValidData();

    if (validData) {
      onInvite(validData);
    }
  };

  useEffect(() => {
    if (user) {
      inviteFieldRef.current.setFormData(user);
    }
  }, [user]);

  return (
    <Container maxWidth="xs" className={classes.mainContainer}>
      <Typography variant="h5" align="left" paragraph className="page-header">
        {title}
      </Typography>
      <Typography variant="subtitle1" align="left" className="body-copy">
        {hint}
      </Typography>
      <EditFields
        fields={fields}
        data={defaultData}
        labelPosition="top"
        labelClass={classes.bold}
        validate={User.validateCreate}
        useAutoFocus={false}
        ref={inviteFieldRef}
        validationErrors={validationErrors}
      />
      <Typography variant="subtitle1" align="left">
        {note}
      </Typography>

      <Grid container className={classes.submitContainer}>
        <Grid item xs={12} sm={6}>
          <LoadingButton variant="contained" color="primary" fullWidth onClick={onInviteClick} loading$={isSubmitting$}>
            {buttonText}
          </LoadingButton>
        </Grid>
      </Grid>
    </Container>
  );
};
